import React, { useState, useEffect } from 'react';
import axios from 'axios';

import './style.less';

const widget_basket_messages = ({ urls: { BASE_URL, WIDGETS_BASE } }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const source = axios.CancelToken.source() || {};

    const getWidgetData = async () => {
      const SLUG = 'basket-messages';

      try {
        const {
          data: {
            attributes: {
              description: { value },
            },
          },
        } = await axios({
          url: `${BASE_URL}${WIDGETS_BASE}${SLUG}/`,
          cancelToken: source.token,
        });

        setData(value);
      } catch (error) {
        console.error('Cannot get widget data of basket messages', error);
      }
    };

    getWidgetData();

    return () => source.cancel();
  }, [BASE_URL, WIDGETS_BASE]);
  

  if (!data) return <React.Fragment></React.Fragment>;

  return (
    <div className='tfs-widget-basket-messages__container'>
      <div
        dangerouslySetInnerHTML={{
          __html: data,
        }}
        className='tfs-widget-basket-messages__content'
      ></div>
    </div>
  );
};

export default widget_basket_messages;


// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets/widget_basket_messages/index.js